enum TotalAndMarketPenetrationTabTypeEnum {
  ProviderCount = "Provider Count",
  NetworkBreadth = "Network Breadth",
}

export { TotalAndMarketPenetrationTabTypeEnum };
